"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteAnalyticsService = exports.analyticsService = void 0;
var tslib_1 = require("tslib");
var auth_suite_fetch_1 = require("../../../auth-suite-fetch");
var sendAnalyticsIds = function (request) {
    var requestPath = "analytics/ids";
    var payload = tslib_1.__assign({}, request);
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: requestPath,
    });
};
exports.analyticsService = {
    sendAnalyticsIds: sendAnalyticsIds,
};
var AuthSuiteAnalyticsService = /** @class */ (function () {
    function AuthSuiteAnalyticsService() {
        return exports.analyticsService;
    }
    return AuthSuiteAnalyticsService;
}());
exports.AuthSuiteAnalyticsService = AuthSuiteAnalyticsService;
